import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import useUserData from "../useUserData";
import { getAllExchangesWithTheirCoins } from "../../redux/exchange/actions";

function UseFetchAllExchangesWithCoins() {
  const {
    exchangeState: { allExchangesWithCoinsStatus, allExchangesWithCoins },
  } = useSelector((state) => state);

  const { email } = useUserData();

  const dispatch = useDispatch();

  const exchangeList = allExchangesWithCoins?.map(data => data?.exchange);

  useEffect(() => {
    if (
      email &&
      allExchangesWithCoinsStatus !== "loading" &&
      allExchangesWithCoinsStatus !== "error"
    ) {
      if (allExchangesWithCoinsStatus === "success") return;

      dispatch(getAllExchangesWithTheirCoins());
    }
  }, [allExchangesWithCoinsStatus, dispatch, email]);

  return {
    isLoading: allExchangesWithCoinsStatus === "loading",
    allExchangesWithCoins,
    exchangeList
  };
}

export default UseFetchAllExchangesWithCoins;
